const onKeyPressNumber = (evt) => {
  if (!/[0-9.]/.test(evt.key)) {
    evt.preventDefault();
  }
};

export default onKeyPressNumber;